import type {
  PlaybookCriterionNode,
  PlaybookId,
} from "@repo/app-types/entities/playbook";
import type { FC } from "react";
import type { PlaybookCriterionTopExample } from "../../api/entities/performancePlaybook.js";
import { appPaths } from "../../app/appPaths.js";
import { CriteriaScoreCard } from "./criteriaScoreCard.js";

export interface CriterionTeamExamplesViewProps {
  playbookId: PlaybookId;
  criterion: PlaybookCriterionNode;
  sortedGradings: readonly PlaybookCriterionTopExample[];
}

export const CriterionTeamExamplesView: FC<CriterionTeamExamplesViewProps> = (
  props,
) => {
  const { playbookId, criterion, sortedGradings } = props;

  if (sortedGradings.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2">
      <div className="text-sm font-semibold text-foreground">
        More examples to learn from
      </div>
      <div className="overflow-x-auto px-1 py-1">
        <div className="flex min-w-max gap-3 pr-1">
          {sortedGradings.map(({ grading, teammate }) => (
            <CriteriaScoreCard
              key={grading.id}
              to={appPaths.teammateCallCriterion.build({
                playbookId,
                teammateId: grading.teammate_id,
                gradingId: grading.id,
                criterionId: criterion.id,
              })}
              grading={grading}
              criterion={criterion}
              teammate={teammate}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
